import { useState } from 'react';

import BpkBottomSheet from '@skyscanner/backpack-web/bpk-component-bottom-sheet';
import BpkBreakpoint, {
  BREAKPOINTS,
} from '@skyscanner/backpack-web/bpk-component-breakpoint';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import BpkTooltip from '@skyscanner/backpack-web/bpk-component-tooltip';

import type { PriceBandSubtitleData } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DealsEvolved';

import STYLES from './DealsEvolved.module.scss';

const MobilePriceBandTooltip = ({
  tooltipLink,
  tooltipText,
}: {
  tooltipLink: string;
  tooltipText: string;
}) => {
  const [sheetOpen, setSheetOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={STYLES.DealsEvolved__priceBandSubtitle__tooltipLink}
        aria-label={tooltipText}
        onClick={() => setSheetOpen(true)}
      >
        {tooltipLink}
      </button>
      <BpkBottomSheet
        id="price-band-bottom-sheet"
        isOpen={sheetOpen}
        onClose={() => setSheetOpen(false)}
        title={tooltipLink}
        ariaLabel={tooltipLink}
        closeOnScrimClick
      >
        <BpkText tagName="p" textStyle={TEXT_STYLES.footnote}>
          {tooltipText}
        </BpkText>
      </BpkBottomSheet>
    </>
  );
};

const PriceBandSubtitle = ({
  priceBandSubtitle,
}: {
  priceBandSubtitle: PriceBandSubtitleData;
}) => (
  <div className={STYLES.DealsEvolved__priceBandSubtitle}>
    <div className={STYLES.DealsEvolved__priceBandSubtitle__content}>
      <BpkText className={STYLES.DealsEvolved__priceBandSubtitle__heading}>
        {priceBandSubtitle.heading}
      </BpkText>
      <BpkText className={STYLES.DealsEvolved__priceBandSubtitle__text}>
        {priceBandSubtitle.subtitle}
      </BpkText>
    </div>
    <div className={STYLES.DealsEvolved__priceBandSubtitle__tooltipWrapper}>
      <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
        {(isMobile: boolean) =>
          isMobile ? (
            <MobilePriceBandTooltip
              tooltipLink={priceBandSubtitle.tooltipLink}
              tooltipText={priceBandSubtitle.tooltipText}
            />
          ) : (
            <BpkTooltip
              ariaLabel={priceBandSubtitle.tooltipText}
              id="price-band-tooltip"
              target={
                <button
                  type="button"
                  className={
                    STYLES.DealsEvolved__priceBandSubtitle__tooltipLink
                  }
                  aria-label={priceBandSubtitle.tooltipText}
                >
                  {priceBandSubtitle.tooltipLink}
                </button>
              }
            >
              <div
                className={
                  STYLES.DealsEvolved__priceBandSubtitle__tooltipContent
                }
              >
                {priceBandSubtitle.tooltipText}
              </div>
            </BpkTooltip>
          )
        }
      </BpkBreakpoint>
    </div>
  </div>
);

export default PriceBandSubtitle;
